const Base64toBlob = (base64, filename) => {
  return new Promise((resolve, reject) => {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: 'application/pdf' });
    const file = new File([blob], filename, { type: 'application/pdf' });
    resolve(file);
  });
};

export default Base64toBlob;

const downloadPdfFromBase64 = async (base64PdfData, fileName) => {
  const createBlobAndUrl = (data) =>
    new Promise((resolve) => {
      const byteCharacters = atob(data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const pdfBlob = new Blob(byteArrays, { type: 'application/pdf' });
      const url = window.URL.createObjectURL(pdfBlob);
      resolve(url);
    });

  try {
    const url = await createBlobAndUrl(base64PdfData);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    // Append to HTML link element to the page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error occurred while creating the PDF blob:', error);
  }
};

export { downloadPdfFromBase64 };
